import { render, staticRenderFns } from "./MediaSearch.vue?vue&type=template&id=87005e8e&"
import script from "./MediaSearch.vue?vue&type=script&lang=js&"
export * from "./MediaSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports